import { Outlet } from "react-router-dom";
import { useClientSwitcherStore } from "@/stores/client-switcher.store";

/**
 * The routed page, keyed by the active client: a switch remounts it, so no form
 * that copied the previous client's data into local state (Agente → Ajustes, the
 * KB editor) can save it into the new one — how Loxago's widget settings were
 * written with another tenant's values (2026-10-30). The cache side of the same
 * guarantee is lib/client-scope-cache.ts. Unsaved edits are dropped on a switch.
 */
export function ClientScopedOutlet(): React.JSX.Element {
  const activeClientId = useClientSwitcherStore((s) => s.activeClientId);
  return <Outlet key={activeClientId ?? "none"} />;
}
